import { stringifyQs } from '@dashboard/utils/urls';

export const passwordResetPath = '/reset-password/';
export const passwordResetUrl = passwordResetPath;

export const registerPath = '/register/';
export const registerUrl = registerPath;

export const passwordResetSuccessPath = '/reset-password/success/';
export const passwordResetSuccessUrl = passwordResetSuccessPath;

export const newPasswordPath = '/new-password/';

export const loginCallbackPath = '/login/callback/';

/** Marketing / legal pages (update when NuxNode publishes final URLs). */
export const termsOfServiceUrl = 'https://nuxnode.io/terms';
export const privacyPolicyUrl = 'https://nuxnode.io/privacy';

export interface NewPasswordUrlQueryParams {
  email: string;
  token: string;
}
export const newPasswordUrl = (params?: NewPasswordUrlQueryParams) =>
  newPasswordPath + '?' + stringifyQs(params);

interface LoginOpenidconnectUrlQueryParams {
  code: string;
  state: string;
}
export type LoginUrlQueryParams = LoginOpenidconnectUrlQueryParams;
